export default __webpack_public_path__ + "static/media/Rafael.82b042f3.svg";